omadapp.components.quizz_answer_no_feedback = function($context,data,callback) {
	var t = this
	var $ = jQuery
	t.data =  data
	t.$context = $context
	t.callback = callback
	

	var $js_feedback = $context.find(".js_feedback")
	
	t.inherit = omadapp.controllers.scenes.common_methods.heredar
	t.inherit(omadapp.components.common_answers_methods)

	t.initialize()




}